export default {"src":"/_next/static/media/3.d547eceb.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};